import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as XLSX from 'xlsx';
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import {ConfirmDialogService} from "../../services/confirm-dialog.service";
import * as _ from "lodash";

export class EntityFieldMappingComponent implements IController {

  schemas: any;
  entity: string;
  skipDefaultFields: boolean;
  schemaDefaultFields: any;
  onSchemaCreated: Function;
  onSchemaUpdated: Function;
  onSchemaDeleted: Function;
  onClose: Function;

  public fileCustomNames: any;
  public schema: any;
  public selectedCustomNameOptions: string[];
  public excludedBringozFieldOptions: string[];
  public bringozFieldsMandatoryMap: any;
  public schemaOptionsWrapper: any;
  public schemaFieldsOptionsWrapper: any;
  public bringozFieldDataType: any;

  constructor(private $timeout: ITimeoutService, private batchRequestsService: BatchRequestsService, private confirmDialogService: ConfirmDialogService) {
  }

  $onInit() {
    this.schemaOptionsWrapper = {
      list: this.schemas.map(s => {
        return {id: s.id, name: s.schemaName}
      }), propertyRef: 'name'
    };
    this.schemaFieldsOptionsWrapper = {
      list: this.schemaDefaultFields.map(ebf => {
        return {id: ebf.name, description: ebf.description}
      }), propertyRef: 'description'
    };
  }

  $postLink() {
    const fileUploadInput = document.getElementById('file-upload');
    fileUploadInput.addEventListener('change', (e) => {
      this.onFileChange(e);
    })
  }

  onSelectSchema(schemaId) {
    this.schema = this.schemas.find(s => s.id === schemaId);
    this.initBringozFieldData();
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, {type: 'array'});

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1});
      this.fileCustomNames = jsonData[0];

      this.initFieldMapping(file.name.replace(/\.[^/.]+$/, ""));
      this.initBringozFieldData();

    };

    reader.readAsArrayBuffer(file);
  }

  onAddField(bringozField?) {
    const field = {
      name: bringozField,
      customName: undefined,
      format: undefined
    }
    this.schema.fields.push(field);
  }

  onRemoveField(index) {
    this.schema.fields.splice(index, 1);
  }

  onSelectCustomName(value, index) {
    this.schema.fields[index].customName = value;
    this.selectedCustomNameOptions = _.compact(this.schema.fields.map((f) => f.customName));
  }

  onSelectBringozField(value, index) {
    this.schema.fields[index].name = value;
    this.excludedBringozFieldOptions = this.schema.fields.map((f) => f.name);
  }

  onSelectDateFormat(value, index) {
    this.schema.fields[index].format = value;
  }

  onDefaultDateChange(value, index) {
    this.schema.fields[index].defaultValue = value;
  }


  onSubmit(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.saveSchema()
      }
    }
  }

  onDeleteSchema() {
    this.confirmDialogService.confirm('Delete Schema', 'Are you sure you want to delete this schema?', event)
      .then(() => {
        this.deleteSchema();
      })
  }

  private saveSchema() {
    if (this.schema.id) {
      this.batchRequestsService.editSchema(this.schema)
        .then((schema) => {
          this.onSchemaUpdated({schema: schema});
          this.onClose();
        })
    } else {
      this.batchRequestsService.createSchema(this.schema)
        .then((schema) => {
          this.onSchemaCreated({schema: schema});
          this.onClose();
        })
    }
  }

  private deleteSchema() {
    this.batchRequestsService.deleteSchema(this.schema.id)
      .then(() => {
        this.onSchemaDeleted({schemaId: this.schema.id});
        this.onClose();
      });
  }

  private initBringozFieldData() {
    this.bringozFieldsMandatoryMap = {};
    this.bringozFieldDataType = {};

    const fieldMappingBringozFields = this.schema?.fields?.map(f => f.name);

    this.schemaDefaultFields.forEach((ebf) => {
      this.bringozFieldsMandatoryMap[ebf.name] = ebf.required;
      this.bringozFieldDataType[ebf.name] = ebf.type;

      // skipDefaultFields hosts start from an empty mapping and add every row by hand,
      // so the required fields are not pre-seeded for them.
      if (!this.skipDefaultFields
        && ebf.required && !fieldMappingBringozFields?.includes(ebf.name)) {
        this.onAddField(ebf.name);
      }
    })

    this.excludedBringozFieldOptions = this.schema.fields.map((f) => f.name);
  }

  private initFieldMapping(name) {
    this.schema = {
      schemaName: name,
      entityType: this.entity,
      fields: []
    }

    this.$timeout(() => {
    }, 0);
  }
}

angular
  .module('bringoz.admin.commons')
  .component('entityFieldMapping', {
    bindings: {
      schemas: '<?',
      schemaDefaultFields: '<?',
      skipDefaultFields: '<?',
      entity: '@',
      onSchemaCreated: '&',
      onSchemaUpdated: '&',
      onSchemaDeleted: '&',
      onClose: '&'
    },
    template: require('./entity-field-mapping.html').default,
    controller: EntityFieldMappingComponent
  });

